import axios from 'axios'

const BASE_URI = '/eci/passwordReset'

export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
export const LOADING = 'LOADING'
export const PUSH_ERRORS = 'PUSH_ERRORS'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'

export const resetPassword = (customerId, userId) => {
  return dispatch => {
    dispatch(isLoading(true))
    axios.post(`${BASE_URI}/initiate?_csrf=${CSRFToken}`, {
      params: {
        businessCode: customerId,
        userName: userId,
        ip: '127.0.0.1' // todo: remove this later
      }
    }).then(res => {
      if (res.data) {
        dispatch(resetPasswordSuccess())
      } else {
        dispatch(resetPasswordError())
      }
    }).then(() => {
      dispatch(isLoading(false))
    }).catch(err => {
      dispatch(resetPasswordError(err))
      dispatch(isLoading(false))
    })
  }
}

const resetPasswordSuccess = () => {
  return {
    type: RESET_PASSWORD_SUCCESS,
  }
}

const resetPasswordError = err => {
  return {
    type: RESET_PASSWORD_ERROR,
    error: err
  }
}

const isLoading = bool => {
  return {
    type: LOADING,
    loading: bool
  }
}

export const pushErrors = errors => {
  return {
    type: PUSH_ERRORS,
    errors
  }
}

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES
  }
}